import { Component, Inject, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LeadHistoryService } from './lead-history.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'app-lead-history',
  templateUrl: './lead-history.component.html',
  styleUrls: ['./lead-history.component.scss']
})
export class LeadHistoryComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  isLoading: Subject<boolean> = new Subject<boolean>();
  constructor(public dialogRef: MatDialogRef<LeadHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private leadHistoryService: LeadHistoryService) { }

  leadId: any = '';
  ngOnInit() {
    this.leadId = this.data.leadId;
    this.getHistory()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  leadHistorydDetails: any = [];
  leadHistorydDetailsAll: any = [];
  filters: any = [];
  getHistory() {
    this.leadHistorydDetails = [];
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.leadHistoryService.getHistory(this.leadId).subscribe((response: any) => {
      let responseData: any = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        let tempData: any = responseData.data.leadHistory;
        this.leadHistorydDetails = tempData
        this.leadHistorydDetailsAll = [...this.leadHistorydDetails]
        this.leadHistorydDetails.forEach((element: any) => {
          element.data.forEach((dataObj: any) => {
            const filter = dataObj.output_data.filter;
            if (!this.filters.includes(filter)) {
              if (filter != 'Test Ride' && filter != 'Quotation') {
                this.filters.push(filter);
              }
            }
          });
        });

      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    })
  }


  selectedFilter: any = []
  selectFilter(text: string) {
    if (text) {
      const index = this.selectedFilter.indexOf(text);
      if (index === -1) {
        // If not already selected, add to selected filters
        this.selectedFilter.push(text);
        let filteredData = this.leadHistorydDetailsAll.map((element: any) => {
          return {
            ...element,
            data: element.data.filter((dataObj: any) => {
              return this.selectedFilter.some((filter: string) => dataObj.output_data.filter.toLowerCase().includes(filter.toLowerCase()));
            })
          };
        }).filter((obj: any) => obj.data.length > 0);
        this.leadHistorydDetails = [...filteredData]
      } else {
        // If already selected, remove from selected filters
        this.selectedFilter.splice(index, 1);
        if (this.selectedFilter.length > 0) {
          let filteredData = this.leadHistorydDetailsAll.map((element: any) => {
            return {
              ...element,
              data: element.data.filter((dataObj: any) => {
                return this.selectedFilter.some((filter: string) => dataObj.output_data.filter.includes(filter));
              })
            };
          }).filter((obj: any) => obj.data.length > 0);
          this.leadHistorydDetails = [...filteredData]
        } else {
          this.leadHistorydDetails = [...this.leadHistorydDetailsAll]
        }
      }

    } else {
      this.selectedFilter = []
      this.leadHistorydDetails = [...this.leadHistorydDetailsAll]
    }
  }

  isSelected(data: string): boolean {
    return this.selectedFilter.includes(data);
  }
}
